import { display, height, width } from "@mui/system";

const styles = (theme) => ({
  containerPageTickets: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    height: "100%",

    minHeight: "850px",
  },
  boxLoading: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "500px",
  },
  conatinerBuscar: { width: "100%", padding: "10px 0", maxWidth: "350px" },
  containerTabs: {
    width: "100%",
    padding: "10px 0",
  },
  boxLine: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    background:
      theme.palette.mode === "dark"
        ? theme.palette.background.modalContrast
        : theme.palette.colors.white.light,
    borderRadius: "6px",
    p: 1,
  },
  containerNoTickets: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    pt: 2,
  },
  paperNoTickets: {
    width: "100%",
    height: "65vh",
    position: "relative",
    overflow: "hidden",
  },
  containerTextNoTickets: {
    position: "absolute",
    left: "45%",
    top: "20%",
    transform: "translateX(-50%)",
    "@media (max-width: 700px)": {
      top: "15%",
    },
    "@media (max-width: 600px)": {
      left: "40%",
      top: "12%",
    },
    "@media (max-width: 430px)": {
      left: "40%",
      top: "10%",
    },
  },
  containerTextNoTicketsError: {
    position: "absolute",
    left: "45%",
    top: "25%",
    transform: "translateX(-50%)",
    "@media (max-width: 700px)": {
      left: "38%",
    },
    "@media (max-width: 600px)": {
      left: "40%",
      top: "20%",
    },
    "@media (max-width: 430px)": {
      left: "38%",
      top: "18%",
    },
  },
  containerImgNoTickets: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  img: {
    "@media (max-width: 600px)": {
      width: 500,
    },
    "@media (max-width: 500px)": {
      width: 480,
    },
    "@media (max-width: 460px)": {
      width: 400,
    },
  },
});

export default styles;
